{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2019                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.JsonData;

{$DEFINE NOPP}

interface

uses
   Classes, JS, Web, sysutils, WEBLib.WebTools, Types;

type
  TJsonDataResultEvent = procedure(success: boolean) of object;

  TJsonData = class(TComponent)
  private
    FDataNode: string;
    FReq: TJSXMLHttpRequest;
    FDataArray: TJSArray;

    FOnJsonDataResultEvent: TJsonDataResultEvent;
  protected
    function DoHttpLoadJson(Event: TEventListenerEvent): boolean;
    function DoHttpAbort(Event: TEventListenerEvent): boolean;
  public
    constructor Create(AOwner: TComponent); override;
    procedure LoadFromJSON(const AURL: string; ADataNode: string = '');

    property OnJsonDataResultEvent: TJsonDataResultEvent read FOnJsonDataResultEvent write FOnJsonDataResultEvent;
    property DataArray: TJSArray read FDataArray;
  end;

  TWebJsonData = class(TJSonData);

implementation

constructor TJsonData.Create(AOwner: TComponent);
begin
  inherited;
end;

procedure TJsonData.LoadFromJSON(const AURL: string; ADataNode: string = '');
begin
  FDataNode := ADataNode;
  FReq := TJSXMLHttpRequest.new;
  FReq.addEventListener('load',@DoHttpLoadJson);
  FReq.addEventListener('abort',@DoHttpAbort);
  FReq.open('GET', AURL);
  FReq.send;
end;

function TJsonData.DoHttpAbort(Event: TEventListenerEvent): boolean;
begin
  if Assigned(OnJsonDataResultEvent) then
    OnJsonDataResultEvent(false);

  Result := true;
end;

function TJsonData.DoHttpLoadJson(Event: TEventListenerEvent): boolean;
var
  J: TJSObject;
  req: TJSXMLHttpRequest;

begin
  req := TJSXMLHttpRequest(Event.target);

  if (req.status >= 200) and (req.status <= 208) then
  begin
    J := TJSJSON.parseObject(req.responseText);

    if FDataNode <> '' then
      FDataArray := TJSArray(J.Properties[FDataNode])
    else
      FDataArray := TJSArray(J);

    {sample code to get keys, values, etc.
    if Assigned(JA) then
    begin
      for r := 0 to JA.length - 1 do
      begin
        obj := TJSObject(JA[r]);
        theKeys := TJSObject.keys(obj);
        for c := 0 to length(theKeys)-1 do
          outputdebugstring(
            Format('%s: %s', [
              theKeys[c],
              string(obj.properties[theKeys[c]])
            ]
            ));
      end;
    end;}

    if Assigned(OnJsonDataResultEvent) then
      OnJsonDataResultEvent(true);
  end;

  Result := true;
end;

end.
